/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from 'environments/environment';

declare const localStorage: any;

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'home',
    title: 'Accueil',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/home'
  },
  {
    id: 'alpha_credit_cee_operations',
    title: 'Liste des opérations CEE',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/alpha_credit/alpha_credit_cee_operations'
  },
  {
    id: 'espace_acep',
    title: 'Espace ACEP',
    description: 'Accédez à ACEP',
    type: 'basic',
    icon: 'heroicons_outline:handshake',
    externalLink: true,
    link: environment.ACEP + '?token=' + localStorage.getItem('accessToken'),
    target: '_blank'
  },
  {
    id: 'espace_partenaire_sica',
    title: 'Espace partenaire SICA',
    description: "Accédez à l'espace partenaire de SICA",
    type: 'basic',
    icon: 'heroicons_outline:handshake',
    externalLink: true,
    link:
      environment.SICA +
      'splashscreen?token=' +
      localStorage.getItem('accessToken') +
      '&refreshToken=' +
      encodeURIComponent(localStorage.getItem('refreshToken')) +
      '&flag=false',
    target: '_blank'
  },
  {
    id: 'traitement',
    title: 'Traitement',
    description: 'Traitement des projets de rénovation',
    type: 'collapsable',
    icon: 'heroicons_outline:inventory',
    link: '/traitement',
    children: [
      {
        id: 'projet_avant_travaux_a_traiter',
        title: 'Projets avant travaux à traiter',
        description: 'Liste des projets avant travaux à traiter',
        type: 'basic',
        icon: 'heroicons_outline:reset_wrench',
        link: '/traitement/renovation-projects/projet_avant_travaux_a_traiter',
        children: [
          {
            id: 'projet_avant_travaux_traitement',
            title: 'Traitement avant travaux',
            type: 'basic',
            link: `/traitement/renovation-projects/projet_avant_travaux_a_traiter/projet_avant_travaux_traitement`
          },
          {
            id: 'projet_fiche_informations',
            title: 'Fiche informations projet',
            description: 'Détails du projet de rénovation',
            type: 'basic',
            link: '/traitement/renovation-projects/projet_fiche_informations'
          }
        ]
      },
      {
        id: 'projet_avant_travaux_traites',
        title: 'Projets avant travaux traités',
        description: 'Liste des projets avant travaux traités',
        type: 'basic',
        icon: 'heroicons_outline:reset_wrench',
        link: '/traitement/renovation-projects/projet_avant_travaux_traites'
      },
      {
        id: 'projet_apres_travaux',
        title: 'Projets après travaux',
        description: 'Gestion des projets après travaux',
        type: 'basic',
        icon: 'task_alt',
        link: '/traitement/renovation-projects/projet_apres_travaux',
        children: [
          {
            id: 'projet_apres_travaux_traitement',
            title: 'Traitement après travaux',
            type: 'basic',
            link: `/traitement/renovation-projects/projet_apres_travaux/projet_apres_travaux_traitement`
          }
        ]
      },
      {
        id: 'dossiers_en_cours',
        title: 'Dossiers en cours de traitement',
        description: 'Liste des dossiers en cours de traitement',
        type: 'basic',
        icon: 'heroicons_outline:folder_managed',
        link: '/traitement/renovation-projects/dossiers_en_cours',
        children: [
          {
            id: 'traitement_dossier_en_cours',
            title: 'Traitement du dossier',
            type: 'basic',
            link: '/traitement/renovation-projects/traitement_dossier_en_cours'
          }
        ]
      }
    ]
  },
  {
    id: 'controle_qualite',
    title: 'Contrôle qualité',
    description: 'Suivi des contrôles internes, par contact et sur site',
    type: 'collapsable',
    icon: 'heroicons_outline:book-open',
    link: '/controle_qualite',
    children: [
      {
        id: 'controle_par_contact',
        title: 'Contrôle par contact',
        description: 'Contrôle par contact des dossiers CEE',
        type: 'collapsable',
        icon: 'heroicons_outline:phone',
        link: '/controle_qualite/controle_par_contact',
        children: [
          {
            id: 'controle_par_contact_selection',
            title: 'Sélection CPC',
            description: 'Dossiers éligibles à sélectionner pour le contrôle par contact',
            type: 'basic',
            icon: 'heroicons_outline:check-circle',

            link: '/controle_qualite/controle_par_contact/selection'
          },
          {
            id: 'controle_par_contact_controle',
            title: 'CPC en cours',
            description: 'Dossiers sélectionnés à contrôler par contact',
            type: 'basic',
            icon: 'heroicons_outline:phone-arrow-up-right',
            link: '/controle_qualite/controle_par_contact/control'
          }
        ]
      },
      {
        id: 'controle_sur_site',
        title: 'Contrôle sur site',
        description: 'Contrôle sur site et suivi des SAV',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        // La carte parent ouvre le menu de ses trois sous-modules, sans
        // rediriger directement vers le CSS indirect.
        link: '/controle_qualite/controle_sur_site',
        children: [
          {
            id: 'controles_externes_indirect',
            title: 'Contrôle sur site indirect',
            description: 'Contrôle sur site indirect',
            type: 'basic',
            link: '/controle_qualite/controles_externes_indirect',
            children: [
              {
                id: 'add_edit_controles_externes_indirect',
                title: 'Lots en création',
                description: 'Lots en création',
                type: 'basic',
                link: '/controle_qualite/controles_externes_indirect/add_edit_controles_externes_indirect'
              },
              {
                id: 'batch_details',
                title: 'Détails',
                description: 'Détails du lot',
                type: 'basic',
                link: '/controle_qualite/controles_externes_indirect/details'
              }
            ]
          },
          {
            id: 'suivi_sav',
            title: 'Suivi des SAV',
            description: 'Suivi des SAV',
            type: 'basic',
            link: '/controle_qualite/suivi_sav'
          },
          {
            id: 'control_monitoring',
            title: 'Suivi du contrôle sur site',
            description: 'Suivi du contrôle sur site',
            type: 'basic',
            link: '/controle_qualite/control_monitoring'
          }
        ]
      }
    ]
  },
  {
    id: 'gestion_commerciale',
    title: 'Gestion Commerciale',
    description: 'Finance et facturation COFRAC',
    type: 'collapsable',
    icon: 'heroicons_outline:clipboard-document-list',
    link: '/gestion_commerciale',
    children: [
      {
        id: 'facturation_cofrac',
        title: 'Facturation COFRAC',
        description: 'Suivi de la facturation COFRAC',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/gestion_commerciale/facturation_cofrac'
      },
      {
        id: 'refacturation',
        title: 'Réfacturation COFRAC',
        description: 'Suivi des lots de réfacturation partenaires',
        type: 'basic',
        icon: 'heroicons_outline:receipt-refund',
        link: '/gestion_commerciale/facturation_cofrac/refacturation'
      }
    ]
  },
  {
    id: 'parametrage',
    title: 'Paramétrage',
    description: 'Acteurs, contrats, opérations, produits,...',
    type: 'collapsable',
    icon: 'heroicons_outline:cog',
    link: '/parametrage',
    children: [      
      {
        id: 'acteurs',
        title: 'Acteurs',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        link: '/parametrage/acteurs',
        children: [
          {
            id: 'obliges',
            title: 'Obligés',
            type: 'basic',
            link: '/parametrage/acteurs/obliges',
            children: [
              {
                id: 'oblige_contacts',
                title: "Contacts de l'obligé",
                description: "Liste des contacts de l'obligé",
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/obliges/oblige_contacts'
              },
              {
                id: 'oblige_secteurs_activite',
                title: "Secteurs d'activité de l'obligé",
                description: "Liste des secteur d'activité de l'obligé",
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/obliges/oblige_secteurs_activite'
              }
            ]
          },
          {
            id: 'partenaires',
            title: 'Partenaires',
            type: 'basic',
            link: '/parametrage/acteurs/partenaires',
            children: [
              {
                id: 'partenaire_contacts',
                title: 'Contacts du partenaire',
                description: 'Liste des contacts du partenaire',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/partenaires/partenaire_contacts'
              },
              {
                id: 'partenaire_profils',
                title: 'Profils du partenaire',
                description: 'Liste des profils du partenaire',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/partenaires/partenaire_profils'
              },
              {
                id: 'partenaire_secteurs_activite',
                title: "Secteurs d'activité du partenaire",
                description: "Liste des secteur d'activité du partenaire",
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/partenaires/partenaire_secteurs_activite'
              },
              {
                id: 'partenaire_qualifications',
                title: 'Qualifications du partenaire',
                description: 'Liste des qualifications du partenaire',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/partenaires/partenaire_qualifications'
              },
              {
                id: 'partenaire_soustraitants',
                title: 'Sous-traitants du partenaire',
                description: 'Liste des sous-traitants du partenaire',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/partenaires/partenaire_soustraitants'
              },
              {
                id: 'partenaire_organismes_controle',
                title: 'Organismes de contrôle du partenaire',
                description: 'Liste des organismes de contrôle du partenaire',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/partenaires/partenaire_organismes_controle'
              }
            ]
          },
          {
            id: 'mandataires',
            title: 'Mandataires',
            type: 'basic',
            link: '/parametrage/acteurs/mandataires',
            children: [
              {
                id: 'mandataire_contacts',
                title: 'Contacts du mandataire',
                description: 'Liste des contacts du mandataire',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/mandataires/mandataire_contacts'
              }
            ]
          },
          {
            id: 'superviseurs',
            title: 'Superviseurs',
            type: 'basic',
            link: '/parametrage/acteurs/superviseurs',
            children: [
              {
                id: 'superviseur_contacts',
                title: 'Contacts du superviseur',
                description: 'Liste des contacts du superviseur',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/superviseurs/superviseur_contacts'
              },
              {
                id: 'superviseur_mandataires',
                title: 'Mandataires du superviseur',
                description: 'Liste des mandataires du superviseur',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/superviseurs/superviseur_mandataires'
              }
            ]
          },
          {
            id: 'soustraitants',
            title: 'Sous-traitants',
            type: 'basic',
            link: '/parametrage/acteurs/soustraitants',
            children: [
              {
                id: 'soustraitant_contacts',
                title: 'Contacts du sous-traitant',
                description: 'Liste des contacts du sous-traitant',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/soustraitants/soustraitant_contacts'
              },
              {
                id: 'soustraitant_qualifications',
                title: 'Qualifications du sous-traitant',
                description: 'Liste des qualifications du sous-traitant',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/soustraitants/soustraitant_qualifications'
              },
              {
                id: 'soustraitant_partenaires',
                title: 'Partenaires du sous-traitant',
                description: 'Liste des partenaires du sous-traitant',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/soustraitants/soustraitant_partenaires'
              }
            ]
          },
          {
            id: 'apporteurs',
            title: "Apporteurs d'affaires",
            type: 'basic',
            link: '/parametrage/acteurs/apporteurs',
            children: [
              {
                id: 'apporteur_contacts',
                title: "Contacts de l'apporteur d'affaires",
                description: "Liste des contacts de l'apporteur d'affaires",
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/apporteurs/apporteur_contacts'
              }
            ]
          },
          {
            id: 'organismes_controle',
            title: 'Organismes de contrôle',
            type: 'basic',
            link: '/parametrage/acteurs/organismes_controle',
            children: [
              {
                id: 'organisme_controle_partenaires',
                title: 'Partenaires du bureau de contrôle',
                description: 'Liste des partenaires du bureau de contrôle',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/organismes_controle/organisme_controle_partenaires'
              }
            ]
          },
          {
            id: 'bureaux_etudes',
            title: "Bureaux d'études",
            type: 'basic',
            link: '/parametrage/acteurs/bureaux_etudes',
            children: [
              {
                id: 'bureau_etudes_qualifications',
                title: "Qualifications du bureau d'étude",
                description: "Liste des qualifications du bureau d'étude",
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/acteurs/bureaux_etudes/bureau_etudes_qualifications'
              }
            ]
          }
        ]
      },

      {
        id: 'contrats',
        title: 'Contrats',
        type: 'collapsable',
        icon: 'description',
        link: '/parametrage/contrats',
        children: [
          {
            id: 'contrats_cee_partenaire',
            title: 'Contrats CEE Partenaire',
            type: 'basic',
            link: '/parametrage/contrats/contrats_cee_partenaire',
            children: [
              {
                id: 'contrat_cee_partenaire_types_operation',
                title: "Type d'operations",
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_partenaire/contrat_cee_partenaire_types_operation'
              },
              {
                id: 'contrat_cee_partenaire_avenants',
                title: 'Avenants',
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_partenaire/contrat_cee_partenaire_avenants'
              }
            ]
          },
          {
            id: 'contrats_cee_mandataire',
            title: 'Contrats CEE Mandataire',
            type: 'basic',
            link: '/parametrage/contrats/contrats_cee_mandataire',
            children: [
              {
                id: 'contrat_cee_mandataire_types_operation',
                title: "Type d'operations",
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_mandataire/contrat_cee_mandataire_types_operation'
              },
              {
                id: 'contrat_cee_mandataire_avenants',
                title: 'Avenants',
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_mandataire/contrat_cee_mandataire_avenants'
              },
              {
                id: 'contrat_cee_mandataire_partenaires',
                title: 'Partenaires',
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_mandataire/contrat_cee_mandataire_partenaires'
              }
            ]
          },
          {
            id: 'contrats_cee_apporteur',
            title: "Contrats CEE Apporteur d'affaires",
            type: 'basic',
            link: '/parametrage/contrats/contrats_cee_apporteur',
            children: [
              {
                id: 'contrat_cee_apporteur_avenants',
                title: 'Avenants',
                description: 'Liste des avenants',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_apporteur/contrat_cee_apporteur_avenants'
              }
            ]
          },
          {
            id: 'contrats_cee_oblige',
            title: 'Contrats CEE Obligé',
            type: 'basic',
            link: '/parametrage/contrats/contrats_cee_oblige',
            children: [
              {
                id: 'contrat_cee_oblige_avenants',
                title: 'Avenants',
                description: 'Liste des avenants',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/contrats/contrats_cee_oblige/contrat_cee_oblige_avenants'
              }
            ]
          },
          {
            id: 'contrats_mpr_partenaire',
            title: 'Contrats MPR Partenaire',
            type: 'basic',
            link: '/parametrage/contrats/contrats_mpr_partenaire',
            children: [
              {
                id: 'contrat_mpr_partenaire_avenants',
                title: 'Avenants',
                description: 'Liste des avenants',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/contrats/contrats_mpr_partenaire/contrat_mpr_partenaire_avenants'
              }
            ]
          }
        ]
      },
      {
        id: 'operations_produits',
        title: 'Opérations & produits',
        type: 'collapsable',
        icon: 'category',
        link: '/parametrage/operations_produits',
        children: [
          {
            id: 'operations_generiques',
            title: 'Opérations génériques',
            type: 'basic',
            link: '/parametrage/operations_produits/operations_generiques',
            children: [
              {
                id: 'operation_generique_balises_entree',
                title: "Balises d'entrée",
                type: 'basic',
                link: '/parametrage/operations_produits/operations_generiques/operation_generique_balises_entree'
              },
              {
                id: 'operation_generique_balises_sortie',
                title: 'Balises de sortie',
                type: 'basic',
                link: '/parametrage/operations_produits/operations_generiques/operation_generique_balises_sortie'
              },
              {
                id: 'operation_generique_mapping_interne',
                title: 'Mapping interne',
                type: 'basic',
                link: '/parametrage/operations_produits/operations_generiques/operation_generique_mapping_interne'
              },
              {
                id: 'operation_generique_produits_generiques',
                title: 'Produits génériques',
                type: 'basic',
                link: '/parametrage/operations_produits/operations_generiques/operation_generique_produits_generiques'
              },
              {
                id: 'operation_generique_produit_generique_balises_entree',
                title: 'Mapping des entrées',
                type: 'basic',
                link: '/parametrage/operations_produits/operations_generiques/operation_generique_produit_generique_balises_entree'
              },
              {
                id: 'operation_generique_produit_generique_balises_sortie',
                title: 'Mapping des sorties',
                type: 'basic',
                link: '/parametrage/operations_produits/operations_generiques/operation_generique_produit_generique_balises_sortie'
              }             
            ]
          },
          {
            id: 'produits_generiques',
            title: 'Produits génériques',
            type: 'basic',
            link: '/parametrage/operations_produits/produits_generiques',
            children: [
              {
                id: 'produit_generique_categories',
                title: 'Catégories',
                type: 'basic',
                link: '/parametrage/operations_produits/produits_generiques/produit_generique_categories'
              },
              {
                id: 'produit_generique_libelles_caracteristiques_additionnelles',
                title: 'Libellés des caractéristiques additionnelles',
                type: 'basic',
                link: '/parametrage/operations_produits/produits_generiques/produit_generique_libelles_caracteristiques_additionnelles'
              },
              {
                id: 'produit_generique_caracteristiques',
                title: 'Caractéristiques',
                type: 'basic',
                link: '/parametrage/operations_produits/produits_generiques/produit_generique_caracteristiques'
              }
            ]
          },
          {
            id: 'produits',
            title: 'Produits',
            type: 'basic',
            link: '/parametrage/operations_produits/produits',
            children: [
              {
                id: 'produit_caracteristiques',
                title: 'Caractéristiques',
                type: 'basic',
                link: '/parametrage/operations_produits/produits/produit_caracteristiques'
              }
            ]
          },
          {
            id: 'fiches_operation_cee',
            title: "Fiche d'opération standardisées",
            type: 'basic',
            link: '/parametrage/operations_produits/fiches_operation_cee',
            children: [
              {
                id: 'fiche_operation_cee_distinctions_cas',
                title: 'Distinctions de cas',
                description: "Distinctions de cas pour les fiches d'opération CEE",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_distinctions_cas'
              },
              {
                id: 'fiche_operation_cee_champs',
                title: 'Champs de la fiche opération CEE',
                description: "Champs fiches d'opération CEE",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_champs'
              },
              {
                id: 'fiche_operation_cee_champs_mapping',
                title: 'Mapping des champs de la fiche opération CEE',
                description:
                  "Mapping des champs fiches d'opération CEE avec les balises de sorties de l'opération générique",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_champs_mapping'
              },
              {
                id: 'fiche_operation_cee_css',
                title: "Période d'obligation CSS",
                description: "Période d'obligation du contrôle sur site",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_css'
              },
              {
                id: 'fiche_operation_cee_cpc',
                title: "Période d'obligation CPC",
                description: "Période d'obligation du contrôle par contact",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_cpc'
              },
              {
                id: 'fiche_operation_cee_traitements_specifiques_dova',
                title: 'Traitement spécifique DOVA',
                description: 'Traitement spécifique DOVA',
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_traitements_specifiques_dova'
              },
              {
                id: 'fiche_operation_cee_balises',
                title: 'Balises de la fiche opération CEE',
                description: "Balises de la fiche d'opération CEE",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_balises'
              },
              {
                id: 'fiche_operation_cee_balises_mapping',
                title: 'Mapping des balises de la fiche opération CEE',
                description: "Mapping des balise de la fiche d'opération CEE",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_balises_mapping'
              },
              {
                id: 'fiche_operation_cee_qualifications_partenaire',
                title: 'Qualifications partenaire',
                description: 'Qualifications partenaire',
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_qualifications_partenaire'
              },
              {
                id: 'fiche_operation_cee_documents_obligatoires',
                title: 'Documents obligatoires',
                description: 'Documents obligatoires de la fiche opération CEE',
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_documents_obligatoires'
              },
              {
                id: 'fiche_operation_cee_qualifications_bureau_etude',
                title: "Qualifications bureau d'étude",
                description: "Qualifications bureau d'étude",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_qualifications_bureau_etude'
              },
              {
                id: 'fiche_operation_cee_produits',
                title: 'Produits de la fiche opération CEE',
                description: 'Produits de la fiche opération CEE',
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_produits'
              },
              {
                id: 'fiche_operation_cee_conditions_eligibilite',
                title: "Conditions d'éligibilité de la fiche opération CEE",
                description: "Liste Conditions d'éligibilité de la fiche opération CEE",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_cee/fiche_operation_cee_conditions_eligibilite'
              }
            ]
          },
          {
            id: 'fiches_operation_mpr',
            title: 'Equipements MPR',
            type: 'basic',
            link: '/parametrage/operations_produits/fiches_operation_mpr',
            children: [
              {
                id: 'fiche_operation_mpr_distinctions_cas',
                title: 'Distinctions de cas',
                description: 'Distinctions de cas pour les équipements MPR',
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_distinctions_cas'
              },
              {
                id: 'fiche_operation_mpr_champs',
                title: "Champs de l'équipement MPR",
                description: "Champs de l'équipement MPR",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_champs'
              },
              {
                id: 'fiche_operation_mpr_champs_mapping',
                title: "Mapping des champs de l'équipement MPR",
                description:
                  "Mapping des champs de l'équipement MPR avec les balises de sorties de l'opération générique",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_champs_mapping'
              },
              {
                id: 'fiche_operation_mpr_qualifications_partenaire',
                title: "Qualifications partenaire de l'équipement MPR",
                description: "Qualifications partenaire de l'équipement MPR",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_qualifications_partenaire'
              },
              {
                id: 'fiche_operation_mpr_produits',
                title: "Produits de l'équipement MPR",
                description: "Produits de l'équipement MPR",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_produits'
              },
              {
                id: 'fiche_operation_mpr_plafonds',
                title: "Plafonds de l'équipement MPR",
                description: "Plafonds de l'équipement MPR",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_plafonds'
              },
              {
                id: 'fiche_operation_mpr_conditions_eligibilite',
                title: "Conditions d'éligibilité de l'équipement MPR",
                description: "Liste Conditions d'éligibilité de l'équipement MPR",
                type: 'basic',
                link: '/parametrage/operations_produits/fiches_operation_mpr/fiche_operation_mpr_conditions_eligibilite'
              }
            ]
          },
          {
            id: 'modeles_document',
            title: 'Modèles de document',
            type: 'basic',
            link: '/parametrage/operations_produits/modeles_document'
          },
          {
            id: 'parametres_metier',
            title: 'Paramètres métier',
            type: 'basic',
            link: '/parametrage/operations_produits/parametres_metier',
            children: [
              {
                id: 'parametre_metier_detail',
                title: 'Détail du paramètre métier',
                description: 'Détail du paramètre',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/operations_produits/parametres_metier/parametre_metier_detail'
              }
            ]
          }
        ]
      },
      {
        id: 'parametrage_traitement',
        title: 'Paramétrage traitement',
        type: 'collapsable',
        icon: 'engineering',
        link: '/parametrage/parametrage_traitement',
        children: [
          {
            id: 'renovation_project_fields',
            title: 'Champs du projet de rénovation',
            type: 'basic',
            icon: 'list',
            link: '/parametrage/parametrage_traitement/renovation_project_fields',
            children: [
              {
                id: 'renovation_project_field_source_docs',
                title: 'Documents sources',
                type: 'basic',
                link: '/parametrage/parametrage_traitement/renovation_project_fields/renovation_project_field_source_docs'
              }
            ]
          },
          {
            id: 'processing_steps',
            title: 'Etapes du traitement',
            icon: 'heroicons_outline:flowsheet',
            type: 'basic',
            link: '/parametrage/parametrage_traitement/processing_steps',
            children: [
              {
                id: 'processing_step_rules',
                title: "Règles de l'étape de traitement",
                type: 'basic',
                link: '/parametrage/parametrage_traitement/processing_steps/processing_step_rules'
              },
              {
                id: 'processing_step_designer',
                title: 'Designer',
                type: 'basic',
                link: '/parametrage/parametrage_traitement/processing_steps/processing_step_designer',
                children: [
                  {
                    id: 'processing_section_rules',
                    title: "Règles de la section de l'étape de traitement",
                    type: 'basic',
                    link: '/parametrage/parametrage_traitement/processing_steps/processing_section_rules'
                  },
                  {
                    id: 'section_field_rules',
                    title: 'Règles du champ',
                    type: 'basic',
                    link: '/parametrage/parametrage_traitement/processing_steps/section_field_rules'
                  },
                  {
                    id: 'section_specific_component_rules',
                    title: 'Règles du composant spécifique',
                    type: 'basic',
                    link: '/parametrage/parametrage_traitement/processing_steps/section_specific_component_rules'
                  }
                ]
              },
              {
                id: 'processing_step_document_types',
                title: 'Types de document',
                type: 'basic',
                link: '/parametrage/parametrage_traitement/processing_steps/processing_step_document_types'
              }
            ]
          },
          {
            id: 'prioritization_rules',
            title: 'Règles de priorisation',
            type: 'basic',
            link: '/parametrage/parametrage_traitement/prioritization_rules'
          },
          {
            id: 'tableau_precarite_cee',
            title: 'Précarité CEE',
            type: 'basic',
            link: '/parametrage/parametrage_traitement/tableau_precarite_cee',
            children: [
              {
                id: 'tableau_precarite_cee_detail',
                title: 'Valeurs du tableau de précarité',
                description: 'Détail du tableau de précarité',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/parametrage_traitement/tableau_precarite_cee/tableau_precarite_cee_detail'
              }
            ]
          },
          {
            id: 'tableau_precarite_mpr',
            title: 'Catégories MPR',
            type: 'basic',
            link: '/parametrage/parametrage_traitement/tableau_precarite_mpr',
            children: [
              {
                id: 'tableau_precarite_mpr_detail',
                title: 'Valeurs du tableau de précarité',
                description: 'Détail du tableau de précarité',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/parametrage_traitement/tableau_precarite_mpr/tableau_precarite_mpr_detail'
              }
            ]
          }
        ]
      },
      {
        id: 'comparaison_acep_tera',
        title: 'Comparateur ACEP / TERA',
        description: 'Recette et suivi des écarts des dossiers',
        type: 'basic',
        icon: 'compare_arrows',
        link: '/parametrage/comparaison-acep-tera'
      },
      {
        id: 'integration_externe',
        title: 'Intégrations externes',
        description: 'Relations avec les systèmes tiers (Sica, Dova, Cofrac, Emmy)',
        type: 'collapsable',
        icon: 'heroicons_outline:globe-alt',
        link: '/parametrage/integration_externe',
        children: [
          {
            id: 'champs_sica',
            title: 'Champs Sica',
            type: 'basic',
            link: '/parametrage/integration_externe/champs_sica'
          },
          {
            id: 'dova',
            title: 'Dova',
            type: 'basic',
            link: '/parametrage/integration_externe/dova',
            children: [
              {
                id: 'champs_dova',
                title: 'Champs Dova',
                type: 'basic',
                link: '/parametrage/integration_externe/dova/champs_dova',
                children: [
                  {
                    id: 'champ_dova_documents',
                    title: 'Documents du champ DOVA',
                    type: 'basic',
                    link: '/parametrage/integration_externe/dova/champs_dova/champ_dova_documents'
                  },
                  {
                    id: 'champ_dova_cas_usage',
                    title: "Cas d'usage du champ DOVA",
                    type: 'basic',
                    link: '/parametrage/integration_externe/dova/champs_dova/champ_dova_cas_usage'
                  }
                ]
              },
              {
                id: 'valeurs_extraites_dova',
                title: 'Valeurs extraites Dova',
                type: 'basic',
                link: '/parametrage/integration_externe/dova/valeurs_extraites_dova'
              }
            ]
          },
          {
            id: 'cofrac',
            title: 'Cofrac',
            type: 'basic',
            link: '/parametrage/integration_externe/cofrac',
            children: [
              {
                id: 'champs_cofrac',
                title: 'Champs COFRAC',
                type: 'basic',
                link: '/parametrage/integration_externe/cofrac/champs_cofrac'
              },
              {
                id: 'syntheses_cofrac',
                title: 'Modèles de synthèse COFRAC',
                type: 'basic',
                link: '/parametrage/integration_externe/cofrac/syntheses_cofrac',
                children: [
                  {
                    id: 'syntheses_cofrac_types_operation',
                    title: 'Template operation',
                    type: 'basic',
                    link: '/parametrage/integration_externe/cofrac/syntheses_cofrac/syntheses_cofrac_types_operation'
                  }
                ]
              }
            ]
          },
          {
            id: 'champs_emmy',
            title: 'Champs Emmy',
            type: 'basic',
            link: '/parametrage/integration_externe/champs_emmy'
          }
        ]
      },
      {
        id: 'automatisation',
        title: 'Automatisation',
        type: 'collapsable',
        icon: 'heroicons_outline:lightning-bolt',
        link: '/parametrage/automatisation',
        children: [
          {
            id: 'import_maj_produits',
            title: 'Import & MAJ Produits',
            type: 'basic',
            link: '/parametrage/automatisation/import_maj_produits'
          }
        ]
      },
      {
        id: 'utilisateurs_acces',
        title: 'Utilisateurs & accès',
        type: 'collapsable',
        icon: 'settings_accessibility',
        link: '/parametrage/utilisateurs_acces',
        children: [
          {
            id: 'utilisateurs',
            title: 'Utilisateurs',
            icon: 'heroicons_outline:user',
            type: 'basic',
            link: '/parametrage/utilisateurs_acces/utilisateurs',
            children: [
              {
                id: 'utilisateur_permissions',
                title: "Permissions de l'utilisateur",
                type: 'basic',
                link: '/parametrage/utilisateurs_acces/utilisateurs/permissions'
              }
            ]
          },
          {
            id: 'equipes_gestionnaires',
            title: 'Equipes de gestionnaires',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/parametrage/utilisateurs_acces/equipes_gestionnaires',
            children: [
              {
                id: 'equipe_gestionnaires_gestionnaires',
                title: "Gestionnaires affectés à l'équipe",
                type: 'basic',
                link: '/parametrage/utilisateurs_acces/equipes_gestionnaires/equipe_gestionnaires_gestionnaires'
              },
              {
                id: 'equipe_gestionnaires_partenaires',
                title: "Partenaires affectés à l'équipe",
                type: 'basic',
                link: '/parametrage/utilisateurs_acces/equipes_gestionnaires/equipe_gestionnaires_partenaires'
              }
            ]
          },
          {
            id: 'profile_management',
            title: 'Gestion des profils',
            description: 'Gestion des profils et des permissions',
            icon: 'manage_accounts',
            type: 'basic',
            link: '/parametrage/utilisateurs_acces/gestion_profils',
            children: [
              {
                id: 'permission_management',
                title: 'Permissions',
                description: 'Permissions du profil',
                icon: 'heroicons_outline:cog',
                type: 'basic',
                link: '/parametrage/utilisateurs_acces/gestion_profils/permissions'
              }
            ]
          }
          // Devenu inutile depuis la synchronisation automatique avec les tera components, à supprimer si jamais on ne trouve pas d'utilité à la gestion manuelle des composants
          // {
          //   id: 'component_management',
          //   title: 'Gestion des composants',
          //   description: 'Gestion des composants',
          //   icon: 'heroicons_outline:cog',
          //   type: 'basic',
          //   link: '/parametrage/utilisateurs_acces/gestion_composants'
          // }
        ]
      },
      {
        id: 'parametres_systeme',
        title: 'Paramètres système',
        description: 'Gérez les paramètres structurels / sensibles',
        icon: 'heroicons_outline:cog',
        type: 'basic',
        link: '/parametrage/parametres_systeme',
        children: [
          {
            id: 'parametre_systeme_detail',
            title: 'Détail du paramètre système',
            description: 'Détail du paramètre',
            icon: 'heroicons_outline:cog',
            type: 'basic',
            link: '/parametrage/parametres_systeme/parametre_systeme_detail'
          }
        ]
      }
    ]
  }
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
